module.exports = __webpack_public_path__ + "static/media/21ECLAC6.eb6ab0f8.jpg";